module.exports = function () {
  console.log("Custom instagram embed loaded!");
  var global = this;
  var __BUNDLE_START_TIME__ = this.nativePerformanceNow
      ? nativePerformanceNow()
      : Date.now(),
    __DEV__ = false,
    process = this.process || {};
  process.env = process.env || {};
  process.env.NODE_ENV = process.env.NODE_ENV || 'production';
  !(function (t) {
    'use strict';
    function e() {
      return (s = Object.create(null));
    }
    function r(t) {
      const e = t,
        r = s[e];
      return r && r.isInitialized ? r.publicModule.exports : i(e, r);
    }
    function n(t) {
      const e = t;
      if (s[e] && s[e].importedDefault !== f) return s[e].importedDefault;
      const n = r(e),
        o = n && n.__esModule ? n.default : n;
      return (s[e].importedDefault = o);
    }
    function o(t) {
      const e = t;
      if (s[e] && s[e].importedAll !== f) return s[e].importedAll;
      const n = r(e);
      let o;
      if (n && n.__esModule) o = n;
      else {
        if (((o = {}), n)) for (const t in n) a.call(n, t) && (o[t] = n[t]);
        o.default = n;
      }
      return (s[e].importedAll = o);
    }
    function i(e, r) {
      if (!p && t.ErrorUtils) {
        p = !0;
        let n;
        try {
          n = c(e, r);
        } catch (e) {
          t.ErrorUtils.reportFatalError(e);
        }
        return (p = !1), n;
      }
      return c(e, r);
    }
    function l(t) {
      return { segmentId: t >>> h, localId: t & m };
    }
    function c(e, i) {
      if (!i && I.length > 0) {
        const t = l(e),
          r = t.segmentId,
          n = t.localId,
          o = I[r];
        null != o && (o(n), (i = s[e]));
      }
      const c = t.nativeRequire;
      if (!i && c) {
        const t = l(e),
          r = t.segmentId;
        c(t.localId, r), (i = s[e]);
      }
      if (!i) throw u(e);
      if (i.hasError) throw d(e, i.error);
      i.isInitialized = !0;
      const f = i,
        a = f.factory,
        p = f.dependencyMap;
      try {
        const l = i.publicModule;
        if (((l.id = e), g.length > 0))
          for (let t = 0; t < g.length; ++t) g[t].cb(e, l);
        return (
          a(t, r, n, o, l, l.exports, p),
          (i.factory = void 0),
          (i.dependencyMap = void 0),
          l.exports
        );
      } catch (t) {
        throw (
          ((i.hasError = !0),
          (i.error = t),
          (i.isInitialized = !1),
          (i.publicModule.exports = void 0),
          t)
        );
      }
    }
    function u(t) {
      let e = 'Requiring unknown module "' + t + '".';
      return Error(e);
    }
    function d(t, e) {
      const r = t;
      return Error(
        'Requiring module "' + r + '", which threw an exception: ' + e
      );
    }
    (t.__r = r),
      (t.__d = function (t, e, r) {
        null == s[e] &&
          (s[e] = {
            dependencyMap: r,
            factory: t,
            hasError: !1,
            importedAll: f,
            importedDefault: f,
            isInitialized: !1,
            publicModule: { exports: {} },
          });
      }),
      (t.__c = e),
      (t.__registerSegment = function (t, e) {
        I[t] = e;
      });
    var s = e();
    const f = {},
      a = {}.hasOwnProperty;
    (r.importDefault = n), (r.importAll = o);
    let p = !1;
    const h = 16,
      m = 65535;
    (r.unpackModuleId = l),
      (r.packModuleId = function (t) {
        return (t.segmentId << h) + t.localId;
      });
    const g = [];
    r.registerHook = function (t) {
      const e = { cb: t };
      return (
        g.push(e),
        {
          release: () => {
            for (let t = 0; t < g.length; ++t)
              if (g[t] === e) {
                g.splice(t, 1);
                break;
              }
          },
        }
      );
    };
    const I = [];
  })(
    'undefined' != typeof global
      ? global
      : 'undefined' != typeof window
      ? window
      : this
  );
  __s = { js: {}, css: {} };
  var __d = this.__d;
  __d(
    function (g, r, i, a, m, e, d) {
      'use strict';
      function t(t) {
        return !isNaN(Number(t));
      }
      function n(t, n) {
        t.className += ' ' + n;
      }
      function o(t, n) {
        t.className = t.className.replace(n, '');
      }
      function s(t) {
        const n = document.getElementsByTagName('iframe');
        let o;
        for (let s = n.length - 1; s >= 0; s--) {
          const c = n[s];
          if (c.contentWindow === t.source) {
            o = c;
            break;
          }
        }
        return o;
      }
      function c(t) {
        const n = t.clientWidth,
          o = window.devicePixelRatio;
        return n && o ? parseInt(n * o, 10) : 0;
      }
      function l(t) {
        const n = t.match(_);
        return n
          ? n[1].replace(/^https?:\/\/(www.)?/, 'https://www.') + '/'
          : null;
      }
      function u(t) {
        if (t.hasAttribute(S)) return t.getAttribute(S);
        const n = t.getElementsByTagName('a');
        for (let t = n.length - 1; t >= 0; t--) {
          const o = l(n[t].href);
          if (o) return o;
        }
        return null;
      }
      function p(t) {
        'performance' in window &&
          null != window.performance &&
          'object' == typeof window.performance &&
          'function' == typeof window.performance.now &&
          t(window.performance.now());
      }
      function f(t) {
        if (
          'performance' in window &&
          null != window.performance &&
          'object' == typeof window.performance &&
          'function' == typeof window.performance.getEntries
        ) {
          const n = window.performance
            .getEntries()
            .filter((t) => t.name.match(G));
          n &&
            n.length &&
            'fetchStart' in n[0] &&
            'responseEnd' in n[0] &&
            t(n[0].fetchStart, n[0].responseEnd);
        }
      }
      function w(s, l) {
        const u = W++,
          w = E + u,
          h = {};
        s.id || (s.id = $ + u);
        let y = l.replace(I, '$1/');
        if (
          ((y += 'embed/'),
          s.hasAttribute(A) && (y += 'captioned/'),
          (y += '?cr=1'),
          s.hasAttribute(M))
        ) {
          const n = parseInt(s.getAttribute(M), 10);
          t(n) && (y += '&v=' + n);
        }
        const N = c(s);
        N && (y += '&wp=' + N.toString()),
          (y += '&rd=' + encodeURIComponent(window.location.origin));
        const C = window.location.pathname;
        if (C) {
          const t = C + (window.location.search || '');
          y += '&rp=' + encodeURIComponent(t.substring(0, 200));
        }
        (y = y.replace(j, k)),
          (h.ci = u),
          p(function (t) {
            h.os = t;
          }),
          f(function (t, n) {
            (h.ls = t), (h.le = n);
          });
        const U = encodeURIComponent(JSON.stringify(h)),
          B = document.createElement('iframe');
        (B.className = s.className),
          (B.id = w),
          (B.src = y + '#' + U),
          B.setAttribute('allowTransparency', 'true'),
          B.setAttribute('allowfullscreen', 'true');
        const S = s.style.position;
        S && B.setAttribute(v, S),
          B.setAttribute('frameBorder', '0'),
          B.setAttribute('height', '0'),
          B.setAttribute(L, s.id),
          B.setAttribute('scrolling', 'no'),
          B.setAttribute('style', s.style.cssText + ';' + O),
          (B.style.position = 'absolute'),
          s.parentNode.insertBefore(B, s),
          n(s, T),
          o(s, R),
          (P[w] = !0),
          p(function (t) {
            K[w] = { frameLoading: t };
          }),
          setTimeout(function () {
            b(w);
          }, x);
      }
      function b(t) {
        Object.prototype.hasOwnProperty.call(P, t) && (delete P[t], y());
      }
      function h(t) {
        if (!B.test(t.origin)) return;
        const o = s(t);
        if (!o) return;
        const c = o.id;
        let l;
        try {
          l = JSON.parse(t.data);
        } catch (t) {}
        if (
          'object' != typeof l ||
          'string' != typeof l.type ||
          'object' != typeof l.details
        )
          return;
        const { details: u, type: f } = l;
        let w = null;
        switch (f) {
          case i(d[0]).MOUNTED: {
            const t = document.getElementById(o.getAttribute(L));
            if (
              (t || i(d[1])(0),
              (w = t.clientHeight),
              (o.style.position = o.hasAttribute(v) ? o.getAttribute(v) : ''),
              'object' == typeof u.styles && u.styles.length)
            )
              try {
                for (let t = 0; t < u.styles.length; t++) {
                  const n = u.styles[t][0],
                    s = u.styles[t][1];
                  o.style[n] = s;
                }
              } catch (t) {}
            n(o, U),
              t.parentNode && t.parentNode.removeChild(t),
              b(c),
              p(function (t) {
                K[c] &&
                  ((K[c].contentLoaded = t),
                  window.__igEmbedLoaded &&
                    window.__igEmbedLoaded({ frameId: c, stats: K[c] }));
              });
            break;
          }
          case i(d[0]).LOADING:
            p(function (t) {
              K[c] && (K[c].contentLoading = t);
            });
            break;
          case i(d[0]).MEASURE: {
            const t = u.height;
            D[c] !== t && (w = t);
            break;
          }
          case i(d[0]).UNMOUNTING:
            delete D[c];
        }
        null !== w && (o.height = D[c] = w);
      }
      function y(number = 1) {
        const t = [...document.getElementsByClassName(R)].slice(0, number);
        for (let n = 0; n < t.length; n++) {
          if (Object.keys(P).length >= C) break;
          const o = t[n];
          if ('BLOCKQUOTE' === o.tagName) {
            const t = u(o);
            t && w(o, t);
          }
        }
      }
      function N(number = 1) {
        if (!J) {
          if (H) return;
          H = !0;
        }
        i(d[2])(() => {
          y(number), J || (i(d[3]).add(window, 'message', h.bind(this)), (J = !0));
        });
      }
      const A = 'data-instgrm-captioned',
        E = 'instagram-embed-',
        x = 1e4,
        O =
          '\n  background-color: white;\n  border-radius: 3px;\n  border: 1px solid #dbdbdb;\n  box-shadow: none;\n  display: block;\n  margin: 0;\n  min-width: 326px;\n  padding: 0;\n',
        j = /^https?:\/\//,
        k = 'https://',
        I = /^(.*?)\/?(\?.*|#|$)/,
        C = 3,
        R = 'instagram-media',
        T = 'instagram-media-registered',
        U = 'instagram-media-rendered',
        B = new RegExp(
          '^https?://([\\w-]+\\.)*(' +
            ['instagram\\.com', 'instagr\\.am'].join('|') +
            ')$'
        ),
        L = 'data-instgrm-payload-id',
        $ = 'instagram-media-payload-',
        S = 'data-instgrm-permalink',
        _ = new RegExp(
          '^(' + B.source.replace(/^\^/, '').replace(/\$$/, '') + '/p/[^/]+)'
        ),
        v = 'data-instgrm-preserve-position',
        G = new RegExp(
          '^(' + B.source.replace(/^\^/, '').replace(/\$$/, '') + '/embed\\.js)'
        ),
        M = 'data-instgrm-version',
        D = {};
      let J = !1;
      const P = {};
      let W = 0,
        H = !1;
      const K = {};
      r(d[4]).getGlobalContext().process ||
        (N(), (r(d[4]).getGlobalContext().process = N));
    },
    0,
    [1, 2, 3, 4, 5]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = {
        MOUNTED: 'MOUNTED',
        LOADING: 'LOADING',
        UNMOUNTING: 'UNMOUNTING',
        MEASURE: 'MEASURE',
      };
    },
    1,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      'use strict';
      r(d[0]);
      m.exports = function (n, o, ...t) {
        if (!n) {
          if (void 0 === o) {
            const n = new Error(
              'Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.'
            );
            throw ((n.framesToPop = 1), n);
          }
          {
            const n = new Error(o);
            throw (
              ((n.name = 'Invariant Violation'),
              (n.messageFormat = o),
              (n.messageParams = t.map((n) => String(n))),
              n.stack,
              (n.framesToPop = 1),
              n)
            );
          }
        }
      };
    },
    2,
    [6]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var n = function (...t) {
        return (t = t.map((n) => String(n)))[0].split('%s').length !== t.length
          ? n('ex args number mismatch: %s', JSON.stringify(t))
          : n._prefix + JSON.stringify(t) + n._suffix;
      };
      (n._prefix = '<![EX['), (n._suffix = ']]>'), (m.exports = n);
    },
    6,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      'use strict';
      function t() {
        if (!n) return;
        let t;
        for (; (t = n.shift()); ) t();
        n = null;
      }
      Object.defineProperty(e, '__esModule', { value: !0 });
      let n = null;
      if (r(d[0]).canUseDOM) {
        ('readyState' in document
          ? 'complete' === document.readyState ||
            'loading' !== document.readyState
          : !!document.body) ||
          ((n = []),
          i(d[1]).add(document, 'DOMContentLoaded', t),
          i(d[1]).add(window, 'load', t));
      }
      e.default = function (t) {
        n ? n.push(t) : t();
      };
    },
    3,
    [7, 4]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      'use strict';
      const n = !(
          'undefined' == typeof window ||
          !window.document ||
          !window.document.createElement ||
          window._ssr
        ),
        t = {
          canUseDOM: n,
          canUseWorkers: 'undefined' != typeof Worker,
          canUseEventListeners:
            n && !(!window.addEventListener && !window.attachEvent),
          canUseViewport: n && !!window.screen,
          isInWorker: !n,
        };
      m.exports = t;
    },
    7,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      'use strict';
      Object.defineProperty(e, '__esModule', { value: !0 });
      let t = !1;
      const n = i(d[0])(() => {
          try {
            const n = Object.defineProperty({}, 'passive', {
              get: function () {
                t = !0;
              },
            });
            r(d[1]).canUseDOM &&
              (window.addEventListener('test', null, n),
              window.removeEventListener('test', null, n));
          } catch (t) {}
          return t;
        }),
        s = { capture: !1 };
      class l {
        constructor(t) {
          (this.$EventListenerHelper1 = null), (this.$EventListenerHelper1 = t);
        }
        static add(t, o, c, u = s) {
          let v = u;
          return (
            n() || (v = 'boolean' != typeof u && !!u.capture),
            t.addEventListener(o, c, v),
            new l(() => {
              t.removeEventListener(o, c, v);
            })
          );
        }
        remove() {
          this.$EventListenerHelper1 &&
            (this.$EventListenerHelper1(), (this.$EventListenerHelper1 = null));
        }
      }
      e.default = l;
    },
    4,
    [8, 7]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      function n(c, o) {
        if ('function' != typeof c || (null != o && 'function' != typeof o))
          throw new TypeError(t);
        var f = function () {
          var n = arguments,
            t = o ? o.apply(this, n) : n[0],
            u = f.cache;
          if (u.has(t)) return u.get(t);
          var h = c.apply(this, n);
          return (f.cache = u.set(t, h) || u), h;
        };
        return (f.cache = new (n.Cache || r(d[0]))()), f;
      }
      var t = 'Expected a function';
      (n.Cache = r(d[0])), (m.exports = n);
    },
    8,
    [9]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      function t(t) {
        var o = -1,
          p = null == t ? 0 : t.length;
        for (this.clear(); ++o < p; ) {
          var l = t[o];
          this.set(l[0], l[1]);
        }
      }
      (t.prototype.clear = r(d[0])),
        (t.prototype.delete = r(d[1])),
        (t.prototype.get = r(d[2])),
        (t.prototype.has = r(d[3])),
        (t.prototype.set = r(d[4])),
        (m.exports = t);
    },
    9,
    [10, 11, 12, 13, 14]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function () {
        (this.size = 0),
          (this.__data__ = {
            hash: new (r(d[0]))(),
            map: new (r(d[1]) || r(d[2]))(),
            string: new (r(d[0]))(),
          });
      };
    },
    10,
    [15, 16, 17]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      function t(t) {
        var o = -1,
          p = null == t ? 0 : t.length;
        for (this.clear(); ++o < p; ) {
          var l = t[o];
          this.set(l[0], l[1]);
        }
      }
      (t.prototype.clear = r(d[0])),
        (t.prototype.delete = r(d[1])),
        (t.prototype.get = r(d[2])),
        (t.prototype.has = r(d[3])),
        (t.prototype.set = r(d[4])),
        (m.exports = t);
    },
    15,
    [18, 19, 20, 21, 22]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function () {
        (this.__data__ = r(d[0]) ? r(d[0])(null) : {}), (this.size = 0);
      };
    },
    18,
    [23]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = r(d[0])(Object, 'create');
      m.exports = t;
    },
    23,
    [24]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (n, o) {
        var t = r(d[0])(n, o);
        return r(d[1])(t) ? t : void 0;
      };
    },
    24,
    [25, 26]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (n, o) {
        return null == n ? void 0 : n[o];
      };
    },
    25,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = /^\[object .+?Constructor\]$/,
        o = Function.prototype,
        n = Object.prototype,
        c = o.toString,
        p = n.hasOwnProperty,
        u = RegExp(
          '^' +
            c
              .call(p)
              .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
              .replace(
                /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                '$1.*?'
              ) +
            '$'
        );
      m.exports = function (o) {
        return (
          !(!r(d[0])(o) || r(d[1])(o)) && (r(d[2])(o) ? u : t).test(r(d[3])(o))
        );
      };
    },
    26,
    [27, 28, 29, 30]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (n) {
        var t = typeof n;
        return null != n && ('object' == t || 'function' == t);
      };
    },
    27,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var n = (function () {
        var n = /[^.]+$/.exec(
          (r(d[0]) && r(d[0]).keys && r(d[0]).keys.IE_PROTO) || ''
        );
        return n ? 'Symbol(src)_1.' + n : '';
      })();
      m.exports = function (t) {
        return !!n && n in t;
      };
    },
    28,
    [31]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = r(d[0])['__core-js_shared__'];
    },
    31,
    [32]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = 'object' == typeof self && self && self.Object === Object && self,
        f = r(d[0]) || t || Function('return this')();
      m.exports = f;
    },
    32,
    [33]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = 'object' == typeof g && g && g.Object === Object && g;
      m.exports = t;
    },
    33,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var n = '[object AsyncFunction]',
        t = '[object Function]',
        o = '[object GeneratorFunction]',
        c = '[object Proxy]';
      m.exports = function (u) {
        if (!r(d[0])(u)) return !1;
        var b = r(d[1])(u);
        return b == t || b == o || b == n || b == c;
      };
    },
    29,
    [27, 34]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var n = '[object Null]',
        t = '[object Undefined]',
        o = r(d[0]) ? r(d[0]).toStringTag : void 0;
      m.exports = function (c) {
        return null == c
          ? void 0 === c
            ? t
            : n
          : o && o in Object(c)
          ? r(d[1])(c)
          : r(d[2])(c);
      };
    },
    34,
    [35, 36, 37]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = r(d[0]).Symbol;
    },
    35,
    [32]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = Object.prototype,
        o = t.hasOwnProperty,
        n = t.toString,
        c = r(d[0]) ? r(d[0]).toStringTag : void 0;
      m.exports = function (t) {
        var l = o.call(t, c),
          v = t[c];
        try {
          t[c] = void 0;
        } catch (t) {}
        var p = n.call(t);
        return l ? (t[c] = v) : delete t[c], p;
      };
    },
    36,
    [35]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = Object.prototype.toString;
      m.exports = function (n) {
        return t.call(n);
      };
    },
    37,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = Function.prototype.toString;
      m.exports = function (n) {
        if (null != n) {
          try {
            return t.call(n);
          } catch (t) {}
          try {
            return n + '';
          } catch (t) {}
        }
        return '';
      };
    },
    30,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (t) {
        var s = this.has(t) && delete this.__data__[t];
        return (this.size -= s ? 1 : 0), s;
      };
    },
    19,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var _ = '__lodash_hash_undefined__',
        t = Object.prototype.hasOwnProperty;
      m.exports = function (n) {
        var o = this.__data__;
        if (r(d[0])) {
          var h = o[n];
          return h === _ ? void 0 : h;
        }
        return t.call(o, n) ? o[n] : void 0;
      };
    },
    20,
    [23]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = Object.prototype.hasOwnProperty;
      m.exports = function (o) {
        var n = this.__data__;
        return r(d[0]) ? void 0 !== n[o] : t.call(n, o);
      };
    },
    21,
    [23]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var _ = '__lodash_hash_undefined__';
      m.exports = function (s, t) {
        var h = this.__data__;
        return (
          (this.size += this.has(s) ? 0 : 1),
          (h[s] = r(d[0]) && void 0 === t ? _ : t),
          this
        );
      };
    },
    22,
    [23]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var n = r(d[0])(r(d[1]), 'Map');
      m.exports = n;
    },
    16,
    [24, 32]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      function t(t) {
        var o = -1,
          p = null == t ? 0 : t.length;
        for (this.clear(); ++o < p; ) {
          var l = t[o];
          this.set(l[0], l[1]);
        }
      }
      (t.prototype.clear = r(d[0])),
        (t.prototype.delete = r(d[1])),
        (t.prototype.get = r(d[2])),
        (t.prototype.has = r(d[3])),
        (t.prototype.set = r(d[4])),
        (m.exports = t);
    },
    17,
    [38, 39, 40, 41, 42]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function () {
        (this.__data__ = []), (this.size = 0);
      };
    },
    38,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      var t = Array.prototype.splice;
      m.exports = function (n) {
        var o = this.__data__,
          p = r(d[0])(o, n);
        return !(
          p < 0 ||
          (p == o.length - 1 ? o.pop() : t.call(o, p, 1), --this.size, 0)
        );
      };
    },
    39,
    [43]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (n, t) {
        for (var f = n.length; f--; ) if (r(d[0])(n[f][0], t)) return f;
        return -1;
      };
    },
    43,
    [44]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (n, t) {
        return n === t || (n != n && t != t);
      };
    },
    44,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (t) {
        var _ = this.__data__,
          n = r(d[0])(_, t);
        return n < 0 ? void 0 : _[n][1];
      };
    },
    40,
    [43]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (t) {
        return r(d[0])(this.__data__, t) > -1;
      };
    },
    41,
    [43]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (t, s) {
        var _ = this.__data__,
          n = r(d[0])(_, t);
        return n < 0 ? (++this.size, _.push([t, s])) : (_[n][1] = s), this;
      };
    },
    42,
    [43]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (t) {
        var n = r(d[0])(this, t).delete(t);
        return (this.size -= n ? 1 : 0), n;
      };
    },
    11,
    [45]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (t, n) {
        var _ = t.__data__;
        return r(d[0])(n) ? _['string' == typeof n ? 'string' : 'hash'] : _.map;
      };
    },
    45,
    [46]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (n) {
        var o = typeof n;
        return 'string' == o || 'number' == o || 'symbol' == o || 'boolean' == o
          ? '__proto__' !== n
          : null === n;
      };
    },
    46,
    []
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (t) {
        return r(d[0])(this, t).get(t);
      };
    },
    12,
    [45]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (n) {
        return r(d[0])(this, n).has(n);
      };
    },
    13,
    [45]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      m.exports = function (s, t) {
        var n = r(d[0])(this, s),
          h = n.size;
        return n.set(s, t), (this.size += n.size == h ? 0 : 1), this;
      };
    },
    14,
    [45]
  );
  __d(
    function (g, r, i, a, m, e, d) {
      'use strict';
      Object.defineProperty(e, '__esModule', { value: !0 }),
        window.instgrm || (window.instgrm = { Embeds: {} }),
        (e.getGlobalContext = function () {
          return window.instgrm.Embeds;
        });
    },
    5,
    []
  );
  global.__r(0);
};
